import {DetailTable} from '../../mapping-classes/detail-table';

export class Creditinterest implements DetailTable {
  shieldedText = 'Afgeschermd';
  restrictedData: boolean;
  title: string;
  rowHeaders: string[];
  rowData: any[];
  errorText: string;

  constructor(creditInterest: any) {
    if (!creditInterest || !creditInterest.basicTableData || creditInterest.basicTableData.length === 0) {
      this.createErrorMessage();
    } else {
      this.restrictedData = creditInterest.restrictedData;
      this.rowHeaders = [];
      this.rowData = [];
      this.setRowHeaders();
      this.setRowData(creditInterest.basicTableData);
    }
  }

  createErrorMessage() {
    this.errorText = 'Er zijn geen credit interest gegevens gevonden.';
  }

  setRowHeaders() {
    this.rowHeaders = [
      'level',
      'minimum',
      'interestPercentage',
      'linkId',
      'linkPercentage',
      'storePercentage',
      'minimumPercentage',
      'maximumPercentage',
      'startDate',
    ];
  }

  setRowData(basicTableData) {
    basicTableData.forEach((details) => {
        if (this.restrictedData) {
          details.minimum = this.shieldedText;
          details.interestPercentage = this.shieldedText;
          details.linkPercentage = this.shieldedText;
          details.storePercentage = this.shieldedText;
          details.minimumPercentage = this.shieldedText;
          details.maximumPercentage = this.shieldedText;
        }
        this.rowData.push(details);
    });
  }
}
